import React, { useContext, useState, useEffect } from 'react';
import axios from 'axios';
import DashboardLayout from '../../components/DashboardLayout';
import Dashboard from './Dashboard';
import ItemManagement from './ItemManagement';
import DealerManagement from './DealerManagement';
import { FaHome, FaUsers, FaAddressCard, FaCalendar, FaClock, FaChartLine, FaBell, FaMapMarkedAlt, FaMoneyBill, FaTh, FaCog, FaBoxes, FaArrowDown, FaTruck, FaIndustry, FaExchangeAlt, FaArrowUp, FaBuilding, FaBook, FaFileAlt, FaWarehouse, FaFileInvoice, FaBox, FaFileInvoiceDollar, FaShoppingCart, FaClipboardCheck, FaSync, FaTrash, FaUndo, FaQrcode, FaFilePdf } from 'react-icons/fa';
import { AuthContext } from '../../components/AuthContext';
import CustomerManagement from './CustomerManagement';
import StationManagement from './StationManagement';
import TilesLocationTransfer from './TilesLocationTransfer';
import ApplyLeave from './ApplyLeave';
import FieldVisitManagement from './FieldVisits';
import TallyItemsManagement from './TallyItemsManagement';
import TallyParametersManagement from './TallyParametersManagement';
import DisplayPanelManagement from './DisplayPanelManagement';
import QuotationManagement from './Quotation';
import TeleCallingPaymentManagement from './TeleCallingPayment';
import Reminders from './Reminders';
import Attendance from './Attendance';
import ActivityLogManagement from './Activity';
import BuyerManagement from './Buyers';
import Doors from './Doors';
import DoorsInward from './DoorsInward';
import DoorsOutward from './DoorsOutward';
import DoorsParameters from './DoorsParameters';
import DoorsStockStatus from './DoorsStockStatus';
import Estimate from './Estimate';
import ReferenceManagement from './ReferenceManagement';
import MAManagement from './MAManagement';
import TransporterManagement from './TransporterManagement';
import Inward from './Inward';
// Updated imports: rename Product* to Tiles*
import TilesUI from './TilesUI';
import TilesParameters from './TilesParameters';
import TilesStockStatus from './TilesStockStatus';
import TilesInward from './TilesInward';
import TilesDeliveryOrder from './TilesDeliveryOrder';
import DeliveryOrder from './DeliveryOrder';
import TallyQuotation from './TallyQuotation';
import SupplierManagement from './SupplierManagement';
import StockMaster from './StockMaster';
import StockItemsInward from './StockItemsInward';
import StockItemsOutward from './StockItemsOutward';
import StockItemsLocationTransfer from './StockItemsLocationTransfer';
import StockItemsStatus from './StockItemsStatus';
import ProformaInvoice from './ProformaInvoice';
import PurchaseIndent from './PurchaseIndent';
import GoodsReceived from './GoodsReceived';
import ActivityLogsNew from './ActivityLogsNew';
import TilesOutward from './TilesOutward';
import TilesReturn from './TilesReturn';
import GoodsReturn from './GoodsReturn';
import TilesOrder from './TilesOrder';
import TilesReceived from './TilesReceived';
import TilesOrderEnhanced from './TilesOrderEnhanced';
import TilesReceivedEnhanced from './TilesReceivedEnhanced';
import TilesDispatchEntry from './TilesDispatchEntry';
import QuotationNew from './QuotationNew';
import TallyLedgerManagement from './TallyLedgerManagement';
import TallyOperationsPanel from './TallyOperationsPanel';
import GuestMaster from './GuestMaster';
import VisitorManagement from './VisitorManagement';
import ChoiceEntry from './ChoiceEntry';
import PackingSlip from './PackingSlip';
import ReferenceCommission from './ReferenceCommission';
import TilesSalesOrder from './TilesSalesOrder';
import StockItemsOrder from './StockItemsOrder';
import StockItemsDispatch from './StockItemsDispatch';
import StockItemsReceived from './StockItemsReceived';
import StockItemsDestroy from './StockItemsDestroy';
import DemolishedTiles from './DemolishedTiles';
import ConceptProductManagement from './ConceptProductManagement';
import Profile from './Profile';
import PDFCatalogs from './PDFCatalogs';
// Import new report components
import TilesDayBook from './reports/TilesDayBook';
import TilesLedger from './reports/TilesLedger';
import StockItemsDayBook from './reports/StockItemsDayBook';
import StockItemsLedger from './reports/StockItemsLedger';
import QuotationsReports from '../company-head/reports/QuotationsReports';
import ManagementReports from './reports/ManagementReports';
// Helper function to find matching domain config
const findMatchingDomainConfig = (domains = [], hostname) => {
  if (!domains || !domains.length || !hostname) return null;
  
  // First try exact match
  const exactMatch = domains.find(d => d.domainName === hostname);
  if (exactMatch) return exactMatch;

  // Then try includes match
  return domains.find(d => 
    hostname.includes(d.domainName) || 
    d.domainName.includes(hostname)
  );
};

const EmployeeDashboard = () => {
  const { logout, user, currentDomain, activeDomainConfig, setActiveDomainConfig } = useContext(AuthContext);
  const [dashboardAccess, setDashboardAccess] = useState(['dashboard']);
  const [loading, setLoading] = useState(false);
  const [matchingCompany, setMatchingCompany] = useState(null);
  const [companyFetched, setCompanyFetched] = useState(false);

  const dashboardOptions = [
    'delivery-order',
    'tele-calling-payment',
    'item-management',
    'dealer-management',
    'customer-management',
    'buyers',
    'station-management',
    'field-visit',
    'quotation',
    'purchase-indent',
    'goods-received',
    'proforma-invoice',
    'apply-leave',
    'attendance',
    'reminders',
    'activity-log',
    'activity-logs-new',
    'quotations-reports',
    'management-reports',
    'doors',
    'doors-inward',
    'doors-outward',
    'doors-stock-status',
    'doors-parameters',
    'estimate',
    'reference-management',
    'ma-management',
    'transport-management',
    'tiles-master',
    'tiles-parameters',
    'tiles-stock-status',
    'tiles-inward',
    'tiles-outward',
    'tiles-delivery-order',
    'tally-quotation',
    'supplier-management',
    'tiles-location-transfer',
    'tally-items-management',
    'tally-parameters-management',
    'display-panel-management',
    'quotation-new',
    'commission',
    'tally-ledger-management',
    'tally-operations-panel',
    'tiles-day-book',
    'tiles-ledger',
    'stock-master',
    'stock-items-inward',
    'stock-items-outward',
    'stock-items-location-transfer',
    'stock-items-status',
    'choice-entry',
    'guest-master',
    'visitor-management',
    'packing-slip',
    'stock-items-ledger',
    'stock-items-day-book',
    'stock-movement',
    'stock-items-movement',
    'tiles-return',
    'tiles-order',
    'tiles-received',
    'tiles-dispatch-entry',
    'reference-commission',
    'tiles-sales-order',
    'stock-items-order',
    'stock-items-dispatch',
    'stock-items-received',
    'stock-items-destroy',
    'demolished-tiles',
    'concept-product',
    'goods-return',
    'pdf-catalogs',
  ];

  useEffect(() => {
    const fetchCompanyData = async () => {
      // Check if user exists, is Employee role, and either has no company or just an ID
      if (user?.role === 'Employee' && 
          user.user.company && 
          (typeof user.user.company === 'string' || !user.user.company.domains)) {
        
        setLoading(true);
        try {
          // Create secure API instance
          const api = axios.create({
            baseURL: process.env.REACT_APP_API_BASE_URL,
            timeout: 10000,
            withCredentials: true,
          });
          
          // Add token to headers
          const token = localStorage.getItem('token');
          if (token) {
            api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          }
          
          // Get company ID
          const companyId = typeof user.user.company === 'string' ? 
                          user.user.company : 
                          user.user.company._id;
          
          // Fetch the company
          const response = await api.get(`/companies/${companyId}`);
          const companyData = response.data;
          
          // Find matching domain configuration
          if (companyData && companyData.domains) {
            const matchingDomain = findMatchingDomainConfig(companyData.domains, currentDomain);
            if (matchingDomain) {
              setMatchingCompany(companyData);
              setDashboardAccess(matchingDomain.employeeDashboardAccess || ['dashboard']);
              
              // Update activeDomainConfig in context
              if (setActiveDomainConfig) {
                setActiveDomainConfig(matchingDomain);
              }
            } else {
              // If no matching domain, fetch all companies to find one that matches
              const allCompaniesResponse = await api.get('/companies');
              const companies = allCompaniesResponse.data;
              
              // Find a company with a matching domain
              const company = companies.find(company => {
                if (!company.domains) return false;
                return findMatchingDomainConfig(company.domains, currentDomain) !== null;
              });
              
              if (company) {
                // Get matching domain configuration from company
                const matchingDomain = findMatchingDomainConfig(company.domains, currentDomain);
                if (matchingDomain) {
                  setMatchingCompany(company);
                  setDashboardAccess(matchingDomain.employeeDashboardAccess || ['dashboard']);
                  
                  // Update activeDomainConfig in context
                  if (setActiveDomainConfig) {
                    setActiveDomainConfig(matchingDomain);
                  }
                }
              }
            }
          }
        } catch (error) {
          console.error('Error fetching company data:', error);
        } finally {
          setLoading(false);
          setCompanyFetched(true);
        }
      }
    };
    
    fetchCompanyData();
  }, [user, currentDomain, setActiveDomainConfig]);

  // filter out the dashboardAccess that are not in the dashboardOptions
  const filteredDashboardAccess = dashboardAccess.filter((access) => dashboardOptions.includes(access));

  console.log("EmployeeDashboard - dashboardAccess (from state):", dashboardAccess);
  console.log("EmployeeDashboard - filteredDashboardAccess:", filteredDashboardAccess);
  console.log("EmployeeDashboard - user.user.role.dashboardAccess:", user.user.role.dashboardAccess);

  let sidebarLinks = [
    { to: "/employee/dashboard", icon: FaHome, label: "Dashboard", component: <Dashboard dashboardAccess={filteredDashboardAccess || dashboardAccess} /> },
  ];
  console.log("Dashboard Access:", dashboardAccess);
  console.log("User Role:", user.user.role.dashboardAccess); 

  [...new Set(user.user.role.dashboardAccess)].forEach((access) => {
    if (filteredDashboardAccess.includes(access)) {
      switch (access) {
        case 'tele-calling-payment':
          sidebarLinks.push({ to: "/employee/tele-calling-payment", icon: FaMoneyBill, label: "Tele Calling Payment", component: <TeleCallingPaymentManagement />, shortcut: 'Ctrl+P' });
          break;
        case 'item-management':
          sidebarLinks.push({ to: "/employee/item-management", icon: FaAddressCard, label: "Item Management", component: <ItemManagement />, shortcut: 'Ctrl+I' });
          break;
        case 'dealer-management':
          sidebarLinks.push({ to: "/employee/dealer-management", icon: FaUsers, label: "Dealer (B2B)", component: <DealerManagement />, shortcut: 'Alt+D' });
          break;
        case 'customer-management':
          sidebarLinks.push({ to: "/employee/customer-management", icon: FaUsers, label: "Customer (B2C)", component: <CustomerManagement />, shortcut: 'Alt+C' });
          break;
        case 'buyers':
          sidebarLinks.push({ to: "/employee/buyers", icon: FaUsers, label: "Buyers", component: <BuyerManagement />, shortcut: 'Alt+B' });
          break;
        case 'station-management':
          sidebarLinks.push({ to: "/employee/station-management", icon: FaMapMarkedAlt, label: "Station Management", component: <StationManagement />, shortcut: 'Alt+S' });
          break;
        case 'delivery-order':
          sidebarLinks.push({ to: "/employee/delivery-order-new", icon: FaTruck, label: "Delivery Order", component: <DeliveryOrder />, shortcut: 'Ctrl+D' });
          break;
        case 'field-visit': 
          sidebarLinks.push({ to: "/employee/field-visit", icon: FaCalendar, label: "Field Visit", component: <FieldVisitManagement />, shortcut: 'Alt+F' });
          break;
        case 'quotation':
          sidebarLinks.push({ to: "/employee/quotation", icon: FaAddressCard, label: "Quotation", component: <QuotationManagement />, shortcut: 'Alt+Q' });
          break;
        case 'purchase-indent':
          sidebarLinks.push({ to: "/employee/purchase-indent", icon: FaFileInvoice, label: "Purchase Indent", component: <PurchaseIndent />, shortcut: 'Ctrl+U' });
          break;
        case 'goods-received':
          sidebarLinks.push({ to: "/employee/goods-received", icon: FaBox, label: "Goods Received", component: <GoodsReceived />, shortcut: 'Ctrl+G' });
          break;
        case 'proforma-invoice':
          sidebarLinks.push({ to: "/employee/proforma-invoice", icon: FaFileInvoiceDollar, label: "Proforma Invoice", component: <ProformaInvoice />, shortcut: 'Alt+P' });
          break;
        case 'apply-leave':
          sidebarLinks.push({ to: "/employee/apply-leave", icon: FaCalendar, label: "Apply Leave", component: <ApplyLeave />, shortcut: 'Alt+L' });
          break;
        case 'attendance':
          sidebarLinks.push({ to: "/employee/attendance", icon: FaClock, label: "Attendance", component: <Attendance />, shortcut: 'Alt+A' });
          break;
        case 'reminders':
          sidebarLinks.push({ to: "/employee/reminders", icon: FaBell, label: "Reminders", component: <Reminders />, shortcut: 'Alt+R' });
          break;
        case 'activity-log':
          sidebarLinks.push({ to: "/employee/activity-log", icon: FaChartLine, label: "Activity Log", component: <ActivityLogManagement />, shortcut: 'Ctrl+L' });
          break;
        case 'activity-logs-new':
          sidebarLinks.push({ to: "/employee/activity-logs-new", icon: FaChartLine, label: "Activity Logs (New)", component: <ActivityLogsNew />, shortcut: 'Ctrl+N' });
          break;
        case 'quotations-reports':
          sidebarLinks.push({ to: "/employee/quotations-reports", icon: FaFileAlt, label: "Quotations Reports", component: <QuotationsReports />, shortcut: 'Ctrl+W' });
          break;
        case 'management-reports':
          sidebarLinks.push({ to: "/employee/management-reports", icon: FaFileAlt, label: "Management Reports", component: <ManagementReports /> });
          break;
        case 'doors':
          sidebarLinks.push({ to: "/employee/doors", icon: FaAddressCard, label: "Door Master", component: <Doors />, shortcut: 'Ctrl+M' });
          break;
        case 'doors-inward':
          sidebarLinks.push({ to: "/employee/doors-inward", icon: FaAddressCard, label: "Door Inward", component: <DoorsInward />, shortcut: 'Shift+I' });
          break;
        case 'doors-outward':
          sidebarLinks.push({ to: "/employee/doors-outward", icon: FaAddressCard, label: "Door Outward", component: <DoorsOutward />, shortcut: 'Shift+O' });
          break;
        case 'doors-stock-status':
          sidebarLinks.push({ to: "/employee/doors-stock-status", icon: FaAddressCard, label: "Doors Stock Status", component: <DoorsStockStatus />, shortcut: 'Shift+S' });
          break;
        case 'doors-parameters':
          sidebarLinks.push({ to: "/employee/doors-parameters", icon: FaAddressCard, label: "Doors Parameters", component: <DoorsParameters />, shortcut: 'Shift+P' });
          break;
        case 'estimate':
          sidebarLinks.push({ to: "/employee/estimate", icon: FaAddressCard, label: "Estimate", component: <Estimate />, shortcut: 'Alt+E' });
          break;
        case 'reference-management':
          sidebarLinks.push({ to: "/employee/reference-management", icon: FaAddressCard, label: "Reference Management", component: <ReferenceManagement />, shortcut: 'Ctrl+R' });
          break;
        case 'ma-management':
          sidebarLinks.push({ to: "/employee/ma-management", icon: FaUsers, label: "Master Account Management", component: <MAManagement />, shortcut: 'Alt+M' });
          break;
        case 'transport-management':
          sidebarLinks.push({ to: "/employee/transport-management", icon: FaAddressCard, label: "Transporter Management", component: <TransporterManagement />, shortcut: 'Ctrl+X' });
          break;
        case 'tiles-master':
          sidebarLinks.push({ to: "/employee/tiles-master", icon: FaTh, label: "Tiles Master", component: <TilesUI />, shortcut: 'Alt+T' });
          break;
        case 'tiles-parameters':
          sidebarLinks.push({ to: "/employee/tiles-parameters", icon: FaCog, label: "Tiles Parameters", component: <TilesParameters />, shortcut: 'Shift+T' });
          break;
        case 'tiles-stock-status':
          sidebarLinks.push({ to: "/employee/tiles-stock-status", icon: FaBoxes, label: "Tiles Stock Status", component: <TilesStockStatus />, shortcut: 'Shift+X' });
          break;
        case 'tiles-inward':
          sidebarLinks.push({ to: "/employee/tiles-inward", icon: FaArrowDown, label: "Tiles Inward", component: <TilesInward />, shortcut: 'Alt+I' });
          break;
        case 'tiles-outward':
          sidebarLinks.push({ to: "/employee/tiles-outward", icon: FaArrowUp, label: "Tiles Outward", component: <TilesOutward />, shortcut: 'Alt+O' });
          break;
        case 'tiles-delivery-order':
          sidebarLinks.push({ to: "/employee/tiles-delivery-order", icon: FaTruck, label: "Tiles Delivery Order", component: <TilesDeliveryOrder />, shortcut: 'Shift+D' });
          break;
        case 'tally-quotation':
          sidebarLinks.push({ to: "/employee/tally-quotation", icon: FaAddressCard, label: "Tally Quotation", component: <TallyQuotation />, shortcut: 'Shift+Q' });
          break;
        case 'supplier-management':
          sidebarLinks.push({ to: "/employee/supplier-management", icon: FaIndustry, label: "Supplier Management", component: <SupplierManagement />, shortcut: 'Ctrl+S' });
          break;
        case 'tiles-location-transfer':
          sidebarLinks.push({ to: "/employee/tiles-location-transfer", icon: FaExchangeAlt, label: "Tiles Location Transfer", component: <TilesLocationTransfer />, shortcut: 'Shift+L' });
          break;
        case 'tiles-day-book':
          sidebarLinks.push({ to: "/employee/tiles-day-book", icon: FaBook, label: "Tiles Day Book", component: <TilesDayBook />, shortcut: 'Ctrl+B' });
          break;
        case 'tiles-ledger':
          sidebarLinks.push({ to: "/employee/tiles-ledger", icon: FaFileAlt, label: "Tiles Ledger", component: <TilesLedger />, shortcut: 'Shift+G' });
          break;
        case 'tally-items-management':
          sidebarLinks.push({ to: "/employee/tally-items-management", icon: FaAddressCard, label: "Tally Items Management", component: <TallyItemsManagement />, shortcut: 'Shift+M' });
          break;
        case 'display-panel-management':
          sidebarLinks.push({ to: "/employee/display-panel-management", icon: FaQrcode, label: "Display Panel Management", component: <DisplayPanelManagement />, shortcut: 'Shift+P' });
          break;
        case 'tally-parameters-management':
          sidebarLinks.push({ to: "/employee/tally-parameters-management", icon: FaCog, label: "Tally Parameters Management", component: <TallyParametersManagement />, shortcut: 'Shift+R' });
          break;
        case 'quotation-new':
          sidebarLinks.push({ to: "/employee/quotation-new", icon: FaAddressCard, label: "Quotation New", component: <QuotationNew />, shortcut: 'Ctrl+Q' });
          break;
        case 'reference-commission':
          sidebarLinks.push({ to: "/employee/reference-commission", icon: FaMoneyBill, label: "Reference Commission", component: <ReferenceCommission />, shortcut: 'Alt+M' });
          break;
        case 'tally-ledger-management':
          sidebarLinks.push({ to: "/employee/tally-ledger-management", icon: FaFileAlt, label: "Tally Ledger Management", component: <TallyLedgerManagement />, shortcut: 'Shift+E' });
          break;
        case 'tally-operations-panel':
          sidebarLinks.push({ to: "/employee/tally-operations-panel", icon: FaSync, label: "Tally Operations Panel", component: <TallyOperationsPanel />, shortcut: 'Alt+O' });
          break;
        case 'stock-master':
          sidebarLinks.push({ to: "/employee/stock-master", icon: FaWarehouse, label: "Stock Master", component: <StockMaster />, shortcut: 'Ctrl+K' });
          break;
        case 'stock-items-inward':
          sidebarLinks.push({ to: "/employee/stock-items-inward", icon: FaArrowDown, label: "Stock Items Inward", component: <StockItemsInward />, shortcut: 'Shift+W' });
          break;
        case 'stock-items-outward':
          sidebarLinks.push({ to: "/employee/stock-items-outward", icon: FaArrowUp, label: "Stock Items Outward", component: <StockItemsOutward />, shortcut: 'Shift+U' });
          break;
        case 'stock-items-location-transfer':
          sidebarLinks.push({ to: "/employee/stock-items-location-transfer", icon: FaExchangeAlt, label: "Stock Items Location Transfer", component: <StockItemsLocationTransfer />, shortcut: 'Shift+A' });
          break;
        case 'stock-items-status':
          sidebarLinks.push({ to: "/employee/stock-items-status", icon: FaBoxes, label: "Stock Items Status", component: <StockItemsStatus />, shortcut: 'Shift+Z' });
          break;
        case 'stock-items-ledger':
          sidebarLinks.push({ to: "/employee/stock-items-ledger", icon: FaFileAlt, label: "Stock Items Ledger", component: <StockItemsLedger />, shortcut: 'Shift+H' });
          break;
        case 'stock-items-day-book':
          sidebarLinks.push({ to: "/employee/stock-items-day-book", icon: FaBook, label: "Stock Items Day Book", component: <StockItemsDayBook />, shortcut: 'Shift+B' });
          break;
        case 'choice-entry':
          sidebarLinks.push({ to: "/employee/choice-entry", icon: FaAddressCard, label: "Choice Entry", component: <ChoiceEntry />, shortcut: 'Alt+H' });
          break;
        case 'guest-master':
          sidebarLinks.push({ to: "/employee/guest-master", icon: FaUsers, label: "Guest Master", component: <GuestMaster />, shortcut: 'Ctrl+H' });
          break;
        case 'visitor-management':
          sidebarLinks.push({ to: "/employee/visitor-management", icon: FaUsers, label: "Visitor Management", component: <VisitorManagement />, shortcut: 'Ctrl+J' });
          break;
        case 'packing-slip':
          sidebarLinks.push({ to: "/employee/packing-slip", icon: FaFileInvoice, label: "Packing Slip", component: <PackingSlip />, shortcut: 'Shift+K' });
          break;
        case 'tally-parameters':
          sidebarLinks.push({ to: "/employee/tally-parameters", icon: FaCog, label: "Tally Parameters", component: <div>Tally Parameters</div>, shortcut: 'Shift+Y' });
          break;
        case 'tiles-return':
          sidebarLinks.push({ to: "/employee/tiles-return", icon: FaWarehouse, label: "Tiles Return", component: <TilesReturn />, shortcut: 'Ctrl+E' });
          break;
        case 'goods-return':
          sidebarLinks.push({ to: "/employee/goods-return", icon: FaUndo, label: "Goods Return", component: <GoodsReturn />, shortcut: 'Alt+G' });
          break;
        case 'tiles-order':
          sidebarLinks.push({ to: "/employee/tiles-order", icon: FaShoppingCart, label: "Tiles Order", component: <TilesOrderEnhanced />, shortcut: 'Ctrl+O' });
          break;
        case 'tiles-dispatch-entry':
          sidebarLinks.push({ to: "/employee/tiles-dispatch-entry", icon: FaTruck, label: "Tiles Dispatch Entry", component: <TilesDispatchEntry />, shortcut: 'Ctrl+H' });
          break;
        case 'tiles-received':
          sidebarLinks.push({ to: "/employee/tiles-received", icon: FaClipboardCheck, label: "Tiles Received", component: <TilesReceivedEnhanced />, shortcut: 'Alt+V' });
          break;
        case 'tiles-sales-order':
          sidebarLinks.push({ to: "/employee/tiles-sales-order", icon: FaShoppingCart, label: "Tiles Sales Order", component: <TilesSalesOrder />, shortcut: 'Ctrl+J' });
          break;
        case 'stock-items-order':
          sidebarLinks.push({ to: "/employee/stock-items-order", icon: FaShoppingCart, label: "Stock Items Order", component: <StockItemsOrder />, shortcut: 'Alt+P' });
          break;
        case 'stock-items-dispatch':
          sidebarLinks.push({ to: "/employee/stock-items-dispatch", icon: FaTruck, label: "Stock Items Dispatch", component: <StockItemsDispatch />, shortcut: 'Alt+D' });
          break;
        case 'stock-items-received':
          sidebarLinks.push({ to: "/employee/stock-items-received", icon: FaClipboardCheck, label: "Stock Items Received", component: <StockItemsReceived />, shortcut: 'Alt+R' });
          break;
        case 'stock-items-destroy':
          sidebarLinks.push({ to: "/employee/stock-items-destroy", icon: FaTrash, label: "Stock Items Destroy", component: <StockItemsDestroy />, shortcut: 'Alt+X' });
          break;
        case 'demolished-tiles':
          sidebarLinks.push({ to: "/employee/demolished-tiles", icon: FaTrash, label: "Demolished Tiles", component: <DemolishedTiles />, shortcut: 'Alt+Z' });
          break;
        case 'concept-product':
          sidebarLinks.push({ to: "/employee/concept-product", icon: FaBoxes, label: "Concept Product", component: <ConceptProductManagement />, shortcut: 'Ctrl+Y' });
          break;
        case 'pdf-catalogs':
          sidebarLinks.push({ to: "/employee/pdf-catalogs", icon: FaFilePdf, label: "PDF Catalogs", component: <PDFCatalogs /> });
          break;
        default:
          break;
      }
    }
  });
  const currentPath = window.location.pathname;
  const matchingLink = sidebarLinks.find(link => link?.to === currentPath);
  
  // Add Profile route
  const isProfilePage = currentPath === "/employee/profile";
  
  return (
    <DashboardLayout 
      title={user.user.name.slice(0, user.user.name.indexOf(' '))} 
      sidebarLinks={sidebarLinks}
      onLogout={() => {
        logout();
        window.location.href = "/";
      }}
      showProfile={true}
      profilePath="/employee/profile"
    >
      {isProfilePage ? <Profile /> : (matchingLink && matchingLink.component)}
    </DashboardLayout>
    );
}

export default EmployeeDashboard;